var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWhiteStar = function SvgWhiteStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 41,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.73 7.804c.467-1.135 2.074-1.135 2.542 0l3.065 7.439 7.978.654c1.2.099 1.703 1.581.811 2.39l-6.184 5.606 2.015 8.515c.286 1.208-1.049 2.146-2.089 1.468L20 29.4l-6.868 4.477c-1.04.677-2.374-.261-2.089-1.469l2.015-8.515-6.184-5.607c-.891-.808-.388-2.29.811-2.389l7.979-.654zM20 11.281l-2.287 5.55a1.38 1.38 0 0 1-1.159.847l-6.079.499 4.755 4.31c.37.337.53.848.414 1.336l-1.52 6.423 5.126-3.341a1.38 1.38 0 0 1 1.501 0l5.125 3.34-1.52-6.422a1.38 1.38 0 0 1 .415-1.336l4.754-4.31-6.078-.499a1.38 1.38 0 0 1-1.16-.847z"
  })));
};
export default SvgWhiteStar;